import React, {PropTypes} from 'react';
import {EditorState} from 'draft-js';
import debounce from 'lodash/debounce';

import {stateFromHTML} from 'draft-js-import-html';
import {stateToHTML} from 'draft-js-export-html';

import Paper from 'material-ui/Paper';

import ErrorContainer from '../ErrorContainer';
import RichTextEditorSingle from './RichTextEditorSingle';
import RichTextEditorToolbar from './RichTextEditorToolbar';
import decorators from './decorators';

let id = 1;

class RichEditor extends React.Component {
  static propTypes = {
    value: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func.isRequired
  };

  debounceChange = debounce(this.fireChangeValue.bind(this), 200);

  componentWillMount() {
    this._id = 'editor' + id++;
    let editorState = this.props.value
      ? EditorState.createWithContent(stateFromHTML(this.props.value), decorators)
      : EditorState.createEmpty(decorators);

    this.state = {
      editorState,
      displayUrlDialog: false
    };

    this.onChange = (editorState) => {
      let oldContentState = this.state.editorState.getCurrentContent();
      this.setState({editorState});
      if (oldContentState !== editorState.getCurrentContent()) {
        this.debounceChange();
      }
    };

    this.onTab = (event) => this._onTab(event);
    this.handleKeyCommand = (command) => this._handleKeyCommand(command);
  }

  componentWillUnmount() {
    this.debounceChange.cancel();
  }

  updateValue(e) {
    let {onBlur} = this.props;

    if (onBlur) {
      onBlur(e);
    }

    this.debounceChange.cancel();
    this.fireChangeValue();
  }

  fireChangeValue() {
    this._compiledValue = stateToHTML(this.state.editorState.getCurrentContent());
    this.props.onChange(this._compiledValue);
  }

  componentWillReceiveProps(newProps) {
    let {value} = newProps;
    this._setValue(value);
  }

  _setValue(value) {
    if (value !== '' && value && value !== this._compiledValue) {
      let state = stateFromHTML(value);
      this._compiledValue = value;
      this.onChange(EditorState.push(this.state.editorState, state));
    }
  }

  render() {
    const {editorState} = this.state;
    const {disabled} = this.props;

    return (
      <ErrorContainer id={this._id} {...this.props}>
        <Paper zDepth={1} rounded={false}>

          <RichTextEditorToolbar
            disabled={disabled}
            editorState={editorState}
            onChange={this.onChange}
          />

          <RichTextEditorSingle
            disabled={disabled}
            editorState={editorState}
            rows={16}
            onBlur={(e) => this.updateValue(e)}
            onChange={this.onChange}
          />
        </Paper>
      </ErrorContainer>
    );
  }
}

export default RichEditor;




// WEBPACK FOOTER //
// ./src/components/form/RichEditor/index.jsx